import {
  Box,
  Checkbox,
  FormControlLabel,
  TextField,
  Typography,
} from '@mui/material';
import { SurveyV2 } from '@act/shared/data-transfer-objects';

interface ICheckpointEditorProps {
  checkpoint: SurveyV2.CreateCheckpointJSONDto;
  onChange: (checkpoint: SurveyV2.CreateCheckpointJSONDto) => void;
}

const CheckpointEditor = ({ checkpoint, onChange }: ICheckpointEditorProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        margin: '8px 0 24px',
      }}
    >
      <Typography variant="bodyLarge">Checkpoint</Typography>

      <TextField
        label="Checkpoint Title"
        value={checkpoint.title}
        onChange={e => onChange({ ...checkpoint, title: e.target.value })}
        fullWidth
      />
      <TextField
        label="Checkpoint Message"
        value={checkpoint.message}
        onChange={e => onChange({ ...checkpoint, message: e.target.value })}
        multiline
        rows={3}
        fullWidth
      />
      <TextField
        label="Checkpoint Summary"
        value={checkpoint.summary}
        onChange={e => onChange({ ...checkpoint, summary: e.target.value })}
        multiline
        rows={2}
        fullWidth
      />
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
        }}
      >
        <TextField
          label="Due date offset (in days)"
          value={checkpoint.dueDateOffsetDays ?? ''}
          onChange={e =>
            onChange({
              ...checkpoint,
              dueDateOffsetDays: e.target.value ? +e.target.value : 0,
            })
          }
          sx={{ width: '180px' }}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={checkpoint.isCompletionCheckpoint}
              onChange={e =>
                onChange({
                  ...checkpoint,
                  isCompletionCheckpoint: e.target.checked,
                })
              }
            />
          }
          label="Is completion checkpoint"
        />
      </Box>
    </Box>
  );
};

export default CheckpointEditor;
